<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId"></topIcon>
    </div>
    <div>
      <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">{{ dominItem.logoName || 'Logo' }}</div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>

    <div style="padding: 0 20%;">
      <div class="real-estate-page">
        <div class="residential-badge">{{ $t('con_recommended') }}</div>
        <hr class="divider" />
        <div class="article-grid">
          <!-- 第一行两篇文章 -->
          <div class="article-item" @click="toDetail(item.articleShortName)" v-for="item in latestNewsList">
            <img
                :src="item.articleImage"
                class="article-img"
            />
            <h2 class="article-title twoHde">{{ item.articleTitle }}</h2>
            <p class="article-desc threeHde">
              {{ item.articleIntro }}
            </p>
          </div>
        </div>


        <div class="article-grid">
          <!-- 第二行四篇文章 -->
          <div class="article-item" style="display: flex" v-for="item in articleList" @click="toDetail(item.articleShortName)">
            <img
                :src="item.articleImage"
                style="width: 200px !important; height: 100px; object-fit: cover;"
            />
            <div>
            <h3 class="article-title small-title twoHde">{{ item.articleTitle }}</h3>
            <p class="article-desc small threeHde">
              {{ item.articleIntro }}
            </p>
            </div>
          </div>
        </div>
      </div>

      <div class="commercial-page">
        <div class="commercial-badge">{{ $t('con_related') }}</div>
        <hr class="divider" />
        <div class="article-grid">
          <div
              v-for="item in recommendList1"
              @click="toDetail(item.articleShortName)"
              :key="item.id"
              class="article-item"
          >
            <img :src="item.articleImage" class="article-img1" />
            <h3 class="article-title small-title twoHde">{{ item.articleTitle }}</h3>
            <p class="article-desc small threeHde">{{ item.articleIntro }}</p>
          </div>
        </div>
      </div>

      <div class="commercial-page">
        <div class="commercial-badge">{{ $t('con_latest') }}</div>
        <hr class="divider" />
        <div class="article-grid">
          <div
              v-for="item in recommendList"
              @click="toDetail(item.articleShortName)"
              class="article-item"
          >
            <img :src="item.articleImage" class="article-img1" />
            <h3 class="article-title small-title twoHde">{{ item.articleTitle }}</h3>
            <p class="article-desc small threeHde">{{ item.articleIntro }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div style="display: flex">
        <div class="logo">{{ dominItem.logoName || 'Logo' }}</div>
        <div class="explore">
          <span>{{ $t('con_Explore') }}</span>
          <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer">{{ item.label }}</span>


        </div>
        <div class="img">
          <img  v-if="dominItem.nationId !== 'cn'" v-for="item in iconListsmall" @click="openLink(item.link)" :src="item.url" alt="">
        </div>
      </div>
      <footers is00="is01" :articleListlast="articleListlast"  :current="current"></footers>

    </div>
  </div>
</template>

<script>
import topIcon from '../../icons/small.vue'
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"
import {getContentList, getLatestNews, getOne, getRecommend} from "@/api";

export default {
  components: {topIcon, buttomIcon, footers},
  props: {
    dominItem: Object
  },
  name: "index",
  data() {
    return {
      bestItem: {},
      recommendList1: [],
      latestNewsList:[],
      articleList: [],
      articleListlast:[],
      recommendList:[],
      latestNewsList1:[],
      recommendList2:[],

      nodata: false,
      template: 'temp3',
      current: 1,
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
    }
  },
  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item

      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getLatestNewsList1()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    openLink(link) {
      window.open(link)
    },
    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },

    // 获取文章列表
    getArticleList() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },

    // 获取最下面文章列表
    getArticleListlast() {
      // this.nodata = true
      getContentList({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    // 获取最后更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 2, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList1() {
      getLatestNews({articleCategoryId: this.current, pageNum: 2, pageSize: 2, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.latestNewsList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 8, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList = res.rows
      })
    },

    getRecommendList1() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 8, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList1 = res.rows
      })
    },

    getRecommendList2() {
      getRecommend({articleCategoryId: this.current, pageNum: 2, pageSize: 4, articleNationId: this.dominItem.nationId}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.recommendList2 = res.rows
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.real-estate-page {
  padding: 20px;
  display: flex;
  flex-direction: column;
  .residential-badge {
    margin: 0 auto 10px;
    display: block;
    background-color: #b32821;
    color: white;
    padding: 5px 15px;
    border-radius: 5px;
    font-weight: bold;
  }

  .divider {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #ccc;
  }

  .article-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 20px;

    .article-item {
      background-color: white;
      padding: 15px;
      border: 1px solid #eee;
      border-radius: 5px;

      .article-img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        margin-bottom: 10px;
        border-radius: 5px;
      }

      .article-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .article-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
      }
    }
  }
}

.commercial-page {
  padding: 20px;
  display: flex;
  flex-direction: column;
  .commercial-badge {
    margin: 0 auto 10px;
    background-color: #b32821;
    color: white;
    padding: 5px 15px;
    border-radius: 5px;
    display: inline-block;
    font-weight: bold;
  }

  .divider {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #ccc;
  }

  .article-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .article-item {
      background-color: white;
      padding: 15px;
      border: 1px solid #eee;
      border-radius: 5px;

      .article-img {
        width: 100%;
        height: auto;
        margin-bottom: 10px;
        border-radius: 5px;
      }

      .article-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .article-desc {
        font-size: 14px;
        color: #666;
        line-height: 1.4;
      }
    }
  }
}

.logo {
  //width: 100%;
  //padding: 10px 20%;
  padding: 10px 0;
  background: #610100;
  box-sizing: border-box;
  font-size: 40px;
  color: #ffffff;
  font-weight: bold;
  text-align: left;
  border-bottom: 1px solid #fff ;
}

.logo-temp1 {
  text-align: center;
}

.logo-temp2 {
  text-align: left;
}

.category {
  width: 100%;
  padding: 0 20%;
  min-height: 50px;
  background: #A30403;
  margin-bottom: 30px;
  color: #fff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 48px;

  span {
    font-weight: 700;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    //border-bottom: 3px solid red;
    color: #000;
    transition: all .5s ease;
  }

  .choose {
    //border-bottom: 3px solid red;
    transition: all .1s ease;
    color:#000;
  }
}

.buttom {
  border-top: 5px solid #610100;
  background: #610100;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .logo{
    border: none;
  }

  display: flex;

  .explore {
    margin: 0 30px;
    display: flex;

    align-items: center;

    span:first-child {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
      color: #ffb7b7;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #610100;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.small-title {
  font-size: 13px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin-left: 10px;
}

.small {
  font-size: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  margin-left: 10px;
  -webkit-line-clamp: 3;
}
.img {
  display: flex;
  align-items: center;
  img{
  width: 20px;
  height: 20px;
}

  img:nth-child(3) {
    width: 30px;
    height: 30px;
  } img:nth-child(4) {
    width: 30px;
    height: 30px;
  }
  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }
}
.temp1{
  padding-left: 20%;
}
.temp3{
  padding-right: 20%;
}

.article-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 10px;
  border-radius: 5px;
}

.article-img1 {
  height: 100px;
  width: 100%;
  object-fit: cover;
}
</style>